const MIN_FONT_SIZE = 100 // %
const DEFAULT_FONT_SIZE = 250 // % — mirror of DEFAULT_FONT_SIZE in bmt/constants.py
const MAX_FONT_SIZE = 800 // %
const MIN_LINE_HEIGHT = 1.5
const DEFAULT_LINE_HEIGHT = 1.65 // mirror of DEFAULT_LINE_HEIGHT in bmt/constants.py
const MAX_LINE_HEIGHT = 2.0

export { DEFAULT_FONT_SIZE, DEFAULT_LINE_HEIGHT, MAX_FONT_SIZE, MAX_LINE_HEIGHT, MIN_FONT_SIZE, MIN_LINE_HEIGHT }
